import { toanQuyen } from './usePermission';
import { useCallback } from 'react';

import { useAuthStore } from '../stores/auth';
import { moduleDauTien } from '../app/modules';
import { TIEN_TO } from '../lib/duong-dan-cong';
import { usePhamVi } from './usePhamVi';

/**
 * Đường dẫn "về nhà" của người đang đăng nhập.
 *
 * - Cổng tenant: `/client` — dashboard nghiệp vụ nằm ở gốc nhánh đó.
 * - Cổng nền tảng: module đầu tiên **người này** vào được, không cố định là
 *   mục đầu danh sách. Người chỉ có quyền nhật ký mà bị đẩy về `Tenant` thì
 *   lại bị đẩy tiếp — vòng chuyển hướng vô tận (xem `moduleDauTien`).
 *
 * Không vào được màn nào thì trả gốc nhánh của cổng đó, để người dùng còn thấy
 * khung ứng dụng và menu tài khoản để đăng xuất, thay vì kẹt ở một màn chặn
 * không lối ra.
 */
export function useManDauTien(): string {
  const user = useAuthStore((s) => s.user);
  const phamVi = usePhamVi();

  const coQuyen = useCallback(
    (ma: string): boolean => {
      if (!user) return false;
      if (toanQuyen(user)) return true;
      return user.permissions.includes(ma);
    },
    [user],
  );

  if (phamVi === 'tenant') return TIEN_TO.tenant;

  const m = moduleDauTien(coQuyen, 'nen-tang');
  return m ? `${TIEN_TO['nen-tang']}/${m.id}` : TIEN_TO['nen-tang'];
}
